/** Local preferences for staking UI (leaderboard, etc.). */

const RECENT_TRAIT_KEY = "owlex-lb-recent-trait";

/** Stored "0" = user turned off; "1" = user turned on; missing = default on. */

/**
 * When true, XP leaderboard may fetch latest trait per holder (extra RPC / logs).
 * Defaults to true when nothing is stored.
 * @returns {boolean}
 */
export function isRecentTraitUnlocked() {
  try {
    const v = localStorage.getItem(RECENT_TRAIT_KEY);
    if (v === "0") return false;
    return true;
  } catch {
    return true;
  }
}

/**
 * @param {boolean} on
 */
export function setRecentTraitUnlocked(on) {
  try {
    if (on) localStorage.setItem(RECENT_TRAIT_KEY, "1");
    else localStorage.setItem(RECENT_TRAIT_KEY, "0");
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent("owlex:leaderboard-settings", {
      detail: { recentTraitUnlocked: on },
    })
  );
}

/**
 * Settings modal: gear in header — toggle "Recent trait unlocked" for leaderboard.
 */
export function initStakingSettings() {
  const modal = document.getElementById("site-settings-modal");
  const openBtn = document.getElementById("btn-site-settings");
  const closeBtn = document.getElementById("site-settings-close");
  const toggle = document.getElementById("setting-recent-trait");
  if (!modal || !openBtn || !toggle) return;

  function syncToggleUi() {
    const on = isRecentTraitUnlocked();
    toggle.setAttribute("aria-checked", on ? "true" : "false");
    if (toggle instanceof HTMLInputElement) toggle.checked = on;
  }

  syncToggleUi();

  openBtn.addEventListener("click", () => {
    syncToggleUi();
    modal.hidden = false;
    document.body.classList.add("site-settings-modal-open");
  });

  function close() {
    modal.hidden = true;
    document.body.classList.remove("site-settings-modal-open");
  }

  closeBtn?.addEventListener("click", close);
  modal.addEventListener("click", (e) => {
    const t = e.target;
    if (t instanceof HTMLElement && t.dataset.settingsClose === "1") close();
  });
  window.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || modal.hidden) return;
    close();
  });

  toggle.addEventListener("change", () => {
    const on = toggle instanceof HTMLInputElement ? toggle.checked : false;
    setRecentTraitUnlocked(on);
  });
}
